import styled, { keyframes } from 'styled-components';

const Loading = () => {
  return (
    <Container>
      <Spinner />
      <Text>잠시만 기다려 주세요.</Text>
    </Container>
  );
};

export default Loading;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 80vh;
  gap: 20px;
`;

export const Text = styled.span`
  font-size: 20px;
  font-weight: bold;
  color: #555;

  @media ${(props) => props.theme.mediaQuery.mobile} {
    font-size: 17px;
  }
`;

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 5px solid #e8e8e8;
  border-top-color: #5b7a8c;
  animation: ${spin} 0.8s linear infinite;

  @media ${(props) => props.theme.mediaQuery.mobile} {
    width: 42px;
    height: 42px;
    border-width: 4px;
  }
`;
